var l={MOBILE_ADD_PLUGIN:"mobile-add-plugin",BLOCK_LINK_MODAL:"block-link-modal",TEXT_LINK_MODAL:"text-link-modal"};export{l as default};
//# sourceMappingURL=EditorModals.js.map
